import React from 'react'

const Map = ({ userLocation, nearbyUsers = [], alerts = [] }) => {
  return (
    <div className="h-full w-full bg-gray-200 flex items-center justify-center rounded-lg">
      <div className="text-center p-4">
        <div className="text-green-600 text-4xl mb-4">🗺️</div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">SafeNav Map</h3>
        {userLocation ? (
          <div className="bg-white p-4 rounded-lg shadow-sm inline-block">
            <p className="text-sm font-medium">Your Location:</p>
            <p className="text-xs text-gray-600">
              {userLocation.latitude.toFixed(6)}, {userLocation.longitude.toFixed(6)}
            </p>
            <p className="text-xs text-gray-600">Speed: {userLocation.speed || 0} km/h</p>
          </div>
        ) : (
          <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200">
            <p className="text-sm text-yellow-800">Waiting for GPS access...</p>
          </div>
        )}
        {alerts.length > 0 && (
          <div className="mt-4 bg-red-50 p-3 rounded-lg border border-red-200">
            <p className="text-sm font-medium text-red-800">Active Alerts: {alerts.length}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Map